
export const LabWallSprite = (
  <>
    <path
      fill="#f2f2f2"
      stroke="#666"
      strokeWidth="4"
      d="M2 2H1502V42H2z"
    />
    <path
      fill="#e6e6e6"
      stroke="#666"
      strokeWidth="4"
      d="M2 42L2 522 642 522 642 122 862 122 862 522 1502 522 1502 42 2 42z"
    />

    {/* Railings */}
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M522 662H562V752H522z"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M942 662H982V752H942z"
    />
    <path
      fill="#f2f2f2"
      stroke="#666"
      strokeWidth="4"
      d="M522 432H562V662H522z"
    />
    <path
      fill="#f2f2f2"
      stroke="#666"
      strokeWidth="4"
      d="M942 432H982V662H942z"
    />
  </>
);

export const ScannerSprite = (
  <rect x="2" y="2" width="30" height="60" fill="#1a1a1a" stroke="#666" strokeWidth="4" />
);

export const ScannerScanLine = (
  <rect x="2" y="2" width="30" height="4" fill="#fff8b8" />
);

export const ScannerScanError = (
  <rect x="4" y="4" width="26" height="56" fill="red" opacity={0.9} />
);

export const LabWallPanelSprite = (
  <>
    <path fill="#1a1a1a" d="M2 2H132V72H2z" />
    <path
      fill="none"
      stroke="#666"
      strokeWidth="4"
      d="M0 72L134 72"
    />
    <path
      fill="none"
      stroke="#3fa9f5"
      strokeWidth="4"
      d="M22 2s10 20 0 40C7.86 70.28 12 82 22 92"
    />
    <path
      fill="none"
      stroke="#ff1d25"
      strokeWidth="4"
      d="M29.47 2c-2.1 10.52-3.83 27.28 2.53 40 10 20 0 40 0 40"
    />
    <path
      fill="none"
      stroke="#ff931e"
      strokeWidth="4"
      d="M12.23 2C13.74 32.25 22 34.74 22 62"
    />
    <path
      fill="none"
      stroke="#666"
      strokeWidth="4"
      d="M2 72L2 2 132 2 132 72"
    />
  </>
);

export const LabWallDoorSprite = (
  <>
    <path
      fill="#808080"
      stroke="#666"
      strokeWidth="4"
      d="M2 2H222V392H2z"
    />
    <path d="M2 2H222V21.5H2z" opacity="0.3" />
    <path
      fill="none"
      stroke="#333"
      strokeWidth={2}
      d="M2 132L222 132"
    />
    <path
      fill="none"
      stroke="#bbb"
      strokeWidth={2}
      d="M2 134L222 134"
    />

    <path
      fill="none"
      stroke="#333"
      strokeWidth={2}
      d="M2 262L222 262"
    />
    <path
      fill="none"
      stroke="#bbb"
      strokeWidth={2}
      d="M2 264L222 264"
    />
  </>
);
